import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.BinaryTextToImage.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.BinaryTextToImage.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = null;
};

EDC.Games.BinaryTextToImage.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.BinaryTextToImage.Scenes.Main.prototype.constructor = EDC.Games.BinaryTextToImage.Scenes.Main;

const BTTI = EDC.Games.BinaryTextToImage.Scenes.Main.prototype;

BTTI.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

BTTI.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(this.game.config.width / 2, 100, 'title').setOrigin(0.5);
  } else {
    const titleFont = {
      font: `${this.gameConfig.titleSize} ${this.gameConfig.font}`,
    };
    title = this.add.text(this.game.config.width / 2,
      120, this.gameConfig.titleTxt, titleFont).setOrigin(0.5);
  }

  if (instructionsImg) {
    instructions = this.add.sprite(580, 760, 'instructions').setOrigin(0);
  } else {
    instructions = this.make.text({
      x: 580,
      y: 760,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 15,
        align: 'center',
      },
    });
  }
  const gumball1 = this.add.sprite(360, 610, 'gumball');
  const gumball2 = this.add.sprite(1605, 625, 'gumball');
  const label1 = this.add.sprite(350, 430, 'label-0');
  const label2 = this.add.sprite(1600, 420, 'label-1');
};

BTTI.loadIteration = function () {
  this.createQuestion();
};

BTTI.createQuestion = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `270px ${this.gameConfig.font}`,
  };
  const container = this.add.container(this.game.config.width / 2, 400);
  const randomCandy = 1 + Math.floor(Math.random() * 4);
  const candy = this.add.sprite(0, 0, `candy-${randomCandy}`);
  const text = this.add.text(0, 10, question, font).setOrigin(0.5);
  container.add(candy);
  container.add(text);
  container.setSize(400, 400);
  this.floatAnimation(container);
  const markAnim = new AnswerMark(this, container).setScale(0.45);
  container.setData('markAnim', markAnim);
  container.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(container);
  this.input.setDraggable(container);
  this.question = container;
  container.on(
    'drag',
    ((sprite, pointer, x, y) => {
      sprite.setPosition(x, y);
    }).bind(this, container),
  );
  container.on('dragend', this.onDragStop.bind(this, container), this);
  container.on('dragstart', this.onDragstart.bind(this, container), this);
};

BTTI.floatAnimation = function (sprite) {
  sprite.getAt(0).clearTint();
  sprite.getAt(1).clearTint();
  sprite.setInteractive();
  this.tweens.add({
    targets: sprite,
    y: sprite.y - 10,
    duration: 1000,
    ease: 'Sine.easeInOut',
    repeat: -1,
    yoyo: true,
  });
};

BTTI.starsAnimation = function (sprite) {
  const randomKey = Math.random() * 100;
  const star = this.add.sprite(sprite.x, sprite.y - 150, 'star-explode').setScale(2.5);
  star.setFrame(0);
  this.anims.create({
    key: randomKey,
    frames: this.anims.generateFrameNumbers('star-explode'),
    frameRate: 7,
    hideOnComplete: true,
  });
  star.play(randomKey);
};

BTTI.onDragstart = function (dragObj) {
  this.tweens.killTweensOf(dragObj);
};

BTTI.onDragStop = function (dragObj) {
  let side;
  if (dragObj.x < 700) {
    side = 0;
    dragObj.x = 355;
    dragObj.y = 770;
    this.checkAnswer(side, dragObj);
  } else if (dragObj.x > 1150) {
    side = 1;
    dragObj.x = 1600;
    dragObj.y = 785;
    this.checkAnswer(side, dragObj);
  } else {
    dragObj.x = this.game.config.width / 2;
    dragObj.y = 400;
    this.floatAnimation(dragObj);
  }
};

BTTI.checkAnswer = function (side, sprite) {
  sprite.disableInteractive();
  const { correctLabel } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (side === correctLabel) {
    this.playCorrect();
    this.starsAnimation(sprite);
    sprite.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2500, this.nextIteration, [], this);
  } else {
    this.playWrong();
    sprite.getAt(0).setTint(0xff0000);
    sprite.getAt(1).setTint(0xff0000);
    this.releaseAnimation(sprite);
  }
};

BTTI.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.question.destroy();
    this.question = null;
    this.loadIteration();
  }
};

BTTI.releaseAnimation = function (sprite) {
  this.tweens.add({
    targets: sprite,
    x: this.game.config.width / 2,
    y: 400,
    duration: 350,
    delay: 2000,
    ease: 'Quint.easeOut',
    onComplete: this.floatAnimation.bind(this, sprite),
  });
};

export default EDC.Games.BinaryTextToImage.Scenes.Main;
